import t from "./highrise1320.mjs";
import m from "./highrise1418.mjs";
var r = "[object Symbol]";
function i(o) {
  return typeof o == "symbol" || m(o) && t(o) == r;
}
export {
  i as default
};
